import Swiper from 'swiper'

export default class TripleImage {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    if (window.innerWidth >= 992) return

    const grid = this.el.querySelector('.triple-image--grid')
    const imgs = [...grid.querySelectorAll('.triple-image--img')]
    const slideCount = imgs.length

    const swiperEl = document.createElement('div')
    swiperEl.className = 'triple-image--swiper swiper'

    const wrapper = document.createElement('div')
    wrapper.className = 'swiper-wrapper'

    const progressBar = document.createElement('div')
    progressBar.className = 'triple-image--progress'
    const progressFill = document.createElement('div')
    progressFill.className = 'triple-image--progress-fill'
    progressBar.appendChild(progressFill)

    imgs.forEach(img => {
      const slide = document.createElement('div')
      slide.className = 'swiper-slide'
      slide.appendChild(img)
      wrapper.appendChild(slide)
    })

    swiperEl.appendChild(wrapper)
    swiperEl.appendChild(progressBar)
    grid.replaceWith(swiperEl)

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: true,
      speed: 600,
      grabCursor: true,
    })

    const animateSlide = () => {
      swiperEl.querySelectorAll('.swiper-slide').forEach(s => s.classList.remove('is-animating'))
      void swiperEl.offsetWidth
      const active = swiperEl.querySelector('.swiper-slide-active')
      if (active) active.classList.add('is-animating')
    }

    let lastIndex = 0
    const updateProgress = () => {
      const index = this.swiper.realIndex
      const isReset = index === 0 && lastIndex === slideCount - 1
      progressFill.style.transition = isReset ? 'none' : 'width 0.4s ease'
      progressFill.style.width = `${((index + 1) / slideCount) * 100}%`
      lastIndex = index
    }

    this.swiper.on('slideChangeTransitionEnd', () => {
      animateSlide()
      updateProgress()
    })

    animateSlide()
    updateProgress()
  }
}
